import * as Sentry from '@sentry/browser';

/**
 * Check whether userData and clientData are valid, non-null objects.
 * Catches the three known failure paths: null/undefined, string from
 * a malformed API response, and array (raw response.data leaked through).
 */
export function isCoreDataValid(userData, clientData) {
	return (
		userData && typeof userData === 'object' && !Array.isArray(userData) &&
		clientData && typeof clientData === 'object' && !Array.isArray(clientData)
	);
}

/**
 * Replace the #loading element with a user-friendly error message
 * and report the failure to Sentry so we can track frequency.
 *
 * @param {string} message  - User-visible text (HTML allowed)
 * @param {string} context  - Internal label for Sentry (e.g. "ReadyToRender guard")
 * @param {Object} [extra]  - Optional key/value pairs attached to the Sentry event
 */
export function showFatalError(message, context, extra) {
	const el = document.getElementById('loading');
	if (el) {
		el.innerHTML = `
			<div class="p-2 center-align" style="max-width: 600px; margin: 0 auto;">
				<div class="mb-4"><img src="./../../resources/assets/fix_car.png" alt="Error" class="responsive-img" style="width:500px; height:auto;"/></div>
				<p class="text-secondary">${message}</p>
			</div>
		`;
	}
	console.error(`[showFatalError] ${context}:`, extra || '');
	Sentry.captureMessage(context, {
		level: 'error',
		extra: extra || {},
	});
}
